import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-find-saving',
  templateUrl: './find-saving.component.html',
  styleUrls: ['./find-saving.component.css']
})
export class FindSavingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
